export const Exemplemix = {
    methods: {
        infoUrl() {
            return location.pathname;
        }, jump(value) {
            if (value == "exit") {
                this.exit();
            } else if (value != this.infoUrl()) {
                this.$ls.set("url", value)
                this.$router.push(value);
            }
        }, exit() {
            this.$store.state.inAk = false;
            this.$ls.clear();
            location.reload()
        },
    }
}